export const styles = {
    xs: {
        serviceButtons: {
            height: "38",
            width: "140",
        },
        substitutionsButtons: {
            height: "26",
            width: "90",
        },
        tipsButtons: {
            height: "26",
            width: "67.5",
        },
    },
    smAndUp: {
        serviceButtons: {
            height: "52",
            width: "180",
        },
        substitutionsButtons: {
            height: "48",
            width: "180",
        },
        tipsButtons: {
            height: "48",
            width: "135",
        },
    },
};
